"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactAdopt = require("react-adopt");

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _reactApollo = require("react-apollo");

var _tempAuthTokenHandler = _interopRequireDefault(require("@devsta/temp-auth-token-handler"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var loadingEl = _react["default"].createElement("span", {
  className: "query__loading"
}, "Loading...");
/**
 * Build a component to display an error. Default behaviour is to show any errors.
 *
 * @param {boolean} shouldDisplayError
 * @param {Object|void} queryError
 *
 * @return {React.node}
 */


function buildError(shouldDisplayError) {
  var queryError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!queryError.message || typeof shouldDisplayError === 'boolean' && !shouldDisplayError) {
    return null;
  }

  return _react["default"].createElement("span", {
    className: "query__error"
  }, "Error! ".concat(queryError.message));
}
/**
 * Allows for context functions that return react elements, or direct
 * React components.
 *
 * @param {Function|React.Node} children
 * @param {Object | void} data
 * @param {Object | Array<Object> | void} errors
 *
 * @return {React.Node}
 */


function getChild(children) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      data = _ref.data,
      error = _ref.error,
      refetch = _ref.refetch,
      loading = _ref.loading;

  if (!children) {
    return null;
  }

  return typeof children === 'function' ? children({
    data: data,
    error: error,
    refetch: refetch,
    loading: loading
  }) : _react["default"].cloneElement(children, {
    data: data,
    error: error,
    refetch: refetch,
    loading: loading
  });
}
/**
 * Gets one or more queries from the originally passed queries. Uses the optionalOn and variables
 * objects to determine which queries to make. All 3 must be the same type, ie. array or singular
 *
 * If the final output is multiple queries, we'll merge into one,
 *
 * @param {Array<QueryType> | QueryType} query
 * @param {Array<string> | string} optionalOn
 * @param {Array<Object> | Object} variables
 *
 * @return {QueryType}
 */


function getQueries(query, optionalOn, variables) {
  var isQueryArray = Array.isArray(query); // If we are passing an array of queries we must also pass an array of optionalOn strings/vars

  if (!optionalOn || !variables || Array.isArray(optionalOn) !== isQueryArray || Array.isArray(variables) !== isQueryArray) {
    // $FlowFixMe - doesn't understand the isQueryArray variable is restricting type
    return query;
  }

  if (!isQueryArray) {
    // $FlowFixMe - doesn't understand the isQueryArray variable is restricting type
    return !variables[optionalOn] ? null : query;
  } // $FlowFixMe - doesn't understand the isQueryArray variable is restricting type


  var filteredQueries = query.filter( // $FlowFixMe - we've already handled a null/undefined variables object above
  function (_, index) {
    return !variables[index] || variables[index][optionalOn[index]];
  });

  if (!filteredQueries.length) {
    return null;
  }

  if (filteredQueries.length === 1) {
    return filteredQueries[0];
  }

  return filteredQueries;
}

function getSingleApolloQuery(variables, query, additionalProps, children) {
  return _react["default"].createElement(_reactApollo.Query, _extends({
    variables: variables,
    query: query
  }, additionalProps), children);
}
/**
 * Composes an array of queries using react-adopt (https://github.com/pedronauck/react-adopt).
 *
 * @param {Array} queries
 * @param {Object} variables
 * @param {Object} queryProps
 *
 * @return {Node}
 */


function getComposedQueries(queries) {
  var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var queryProps = arguments.length > 2 ? arguments[2] : undefined;
  return (0, _reactAdopt.adopt)(queries.reduce(function (composed, query, index) {
    return _objectSpread({}, composed, _defineProperty({}, "".concat(index), function _(_ref2) {
      var render = _ref2.render;
      return getSingleApolloQuery(variables[index], query, queryProps, render);
    }));
  }, {}));
}
/**
 * Takes an array of results and merges the results into a single data object
 *
 * @param {Array<QueryChildProps>} dataValues
 *
 * @return {Object}
 */


function mergeComposedData(dataValues) {
  return dataValues.reduce(function (mergedData, result) {
    return _objectSpread({}, mergedData, {}, result.data);
  }, {});
}
/**
 * Creates an Apollo query. Can pass optionals to determine whether or not to make the query.
 *
 * NOTE. If the queries require DIFFERENT contexts, aka. different API endpoints, you need to make
 * multiple separate requests. You CANNOT batch these queries using this component.
 *
 * @param {Array<Object> | Object} variables
 * @param {React.Node} children
 * @param {Array<string> | string} optionalOn
 * @param {Array<QueryType> | QueryType} query
 * @param {bool} shouldDisplayError
 * @param {*} props
 *
 * @return {React.Node}
 */


var Query = /*#__PURE__*/function (_Component) {
  _inherits(Query, _Component);

  function Query(props) {
    var _this;

    _classCallCheck(this, Query);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Query).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getComposedQueriesChild", (0, _memoizeOne["default"])(function (delegateLoading, children, shouldDisplayError, onCompleted) {
      return function (results) {
        var resultValues = Object.values(results);
        var tempAuthTokenHandler = _this.state.tempAuthTokenHandler;
        var isLoading = resultValues.some(function (result) {
          return result.loading;
        });

        if (isLoading && !delegateLoading) {
          return loadingEl;
        }

        tempAuthTokenHandler.attemptToResetToken();
        var errors = resultValues.map(function (result) {
          return result.error;
        }).filter(Boolean);
        var displayError = errors && errors.length && buildError(shouldDisplayError, errors[0]);

        if (displayError) {
          return displayError;
        }

        var data = mergeComposedData(resultValues);

        if (onCompleted) {
          onCompleted(data);
        }

        return getChild(children, {
          data: data,
          error: errors[0],
          loading: isLoading,
          refetch: void 0
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "getSingleQueryChild", function (delegateLoading, children, shouldDisplayError) {
      return function (_ref3) {
        var loading = _ref3.loading,
            error = _ref3.error,
            data = _ref3.data,
            refetch = _ref3.refetch;

        if (loading && !delegateLoading) {
          return loadingEl;
        }

        var tempAuthTokenHandler = _this.state.tempAuthTokenHandler;
        tempAuthTokenHandler.attemptToResetToken();
        return buildError(shouldDisplayError, error) || getChild(children, {
          data: data,
          error: error,
          refetch: refetch,
          loading: loading
        });
      };
    });

    _this.state = {
      tempAuthTokenHandler: new _tempAuthTokenHandler["default"]()
    };
    return _this;
  }
  /**
   * Returns a function used as a child of several composed ApolloQueries. Handles loading/error/
   * data states across all results/queries
   *
   * @param {Node} children
   * @param {boolean} shouldDisplayError
   * @param {Function} onCompleted
   *
   * @return {Function}
   */


  _createClass(Query, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          variables = _this$props.variables,
          children = _this$props.children,
          delegateLoading = _this$props.delegateLoading,
          optionalOn = _this$props.optionalOn,
          query = _this$props.query,
          shouldDisplayError = _this$props.shouldDisplayError,
          onCompleted = _this$props.onCompleted,
          tempAuthToken = _this$props.tempAuthToken,
          props = _objectWithoutProperties(_this$props, ["variables", "children", "delegateLoading", "optionalOn", "query", "shouldDisplayError", "onCompleted", "tempAuthToken"]);

      var tempAuthTokenHandler = this.state.tempAuthTokenHandler;
      var filteredQueries = getQueries(query, optionalOn, variables);

      if (!filteredQueries) {
        return getChild(children);
      }

      tempAuthTokenHandler.attemptToOverrideToken(tempAuthToken);

      if (!Array.isArray(filteredQueries)) {
        return getSingleApolloQuery(variables, filteredQueries, _objectSpread({}, props, {
          onCompleted: onCompleted
        }), this.getSingleQueryChild(delegateLoading, children, shouldDisplayError));
      }

      var ComposedQueries = getComposedQueries(filteredQueries, variables, props);
      return _react["default"].createElement(ComposedQueries, null, this.getComposedQueriesChild(delegateLoading, children, shouldDisplayError, onCompleted));
    }
  }]);

  return Query;
}(_react.Component);

exports["default"] = Query;

_defineProperty(Query, "defaultProps", {
  shouldDisplayError: true
});